import { SITE_TYPE } from '@klareospace/pharos-lib-types';
import type { SiteType } from '@klareospace/pharos-lib-types';

// ─── Site Type Label Keys (i18n) ────────────────────────────────────────────────────────

export const SITE_TYPE_LABEL_KEY: Record<SiteType, string> = {
  [SITE_TYPE.RELAY]: 'mainSelector.siteTypes.relay',
  [SITE_TYPE.SHOP]: 'mainSelector.siteTypes.shop',
  [SITE_TYPE.WAREHOUSE]: 'mainSelector.siteTypes.warehouse',
};
